import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.bg{min-height:100vh;}.ssr-plugin'
import '.bh{margin-bottom:2rem;}.ssr-plugin'
import '.ao{max-width:77.5rem;}.ssr-plugin'
import '.an{margin-bottom:5rem;}.ssr-plugin'
import '.al{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Style, styled } from 'inlines'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import Footer from '@app/components/blocks/footer/Footer'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Head } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { rootDomain } from '@app/util/links'

export const PageLayout = ({
  gap = '1rem',
  standardPageTitle = true,
  children,
  marginTop = '2rem',
  style,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  standardPageTitle?: boolean
  children: ReactNode
  marginTop?: string
  style?: Style
}) => {
  const isMobile = useMediaQuery()
  const [location] = useLocation()
  return (
    <styled.div className="a c n b as"
      style={{
        ...style,
      }}
    >
      {standardPageTitle && (
        <Head>
          <title>CrowdBuilding</title>
        </Head>
      )}
      <Head>
        <link rel="canonical" href={`${rootDomain}${location}`} />
      </Head>
      <TopNavBar />
      <div className="bg bh ao"
        style={{
          width: isMobile ? '100%' : '85%',
          paddingInline: isMobile ? '1rem' : 0,
        }}
      >
        <styled.main className="an a b al"
          style={{
            marginTop,
            gap: gap,
            paddingInline: isMobile ? 0 : '1rem',
          }}
        >
          {children}
        </styled.main>

        <Footer />
      </div>
    </styled.div>
  )
}
